const PermissionPlugin = {
    install(Vue, options) {
        // 可在组件中通过 this.$checkPermission() 调用
       Vue.prototype.$checkPermission= function (permissionKey) {
        let permissions = {}
        if(this.$store.getters.userInfo) {
            permissions = this.$store.getters.userInfo.permissions || [];
        }
        if(permissions['*:*:*']) {
            return true;
        }
        // 判断用户是否有该权限
        return permissions[permissionKey];
       }
      
    
    },
};
export default PermissionPlugin